export default __webpack_public_path__ + "static/media/bs2.2.e86bf5d2.png";